export function handlerNotRouters(router: string) {
  if (router === "") {
    return;
  }
  window.open(router, "_self");
}
